import { Agent, Channel, MerchantStructure } from '@nemuru-eng/js-api-client';
import { generatePath } from 'react-router-dom';

import { useScreen } from '../../../../../../hooks/useScreen';
import { DYNAMIC_PAGE_PATHS } from '../../../../../views/DynamicPageView/config/shared/pathRoutes';
import { AgentCard } from '../StructureCard/AgentCard';

interface AgentListProps {
  agents: Agent[];
  agentSearchTerm: string;
  merchantStructure: MerchantStructure;
  selectedChannel?: Channel;
  agentFoundBySearch?: Agent;
  editModeAllowed?: boolean;
  isAgentRedirectAllowed?: boolean;
}

export const AgentList = ({
  agents,
  agentSearchTerm,
  merchantStructure,
  selectedChannel,
  agentFoundBySearch,
  editModeAllowed = false,
  isAgentRedirectAllowed,
}: AgentListProps) => {
  const { isMobile } = useScreen();

  const redirectPath = (agentId: string) =>
    selectedChannel
      ? generatePath(DYNAMIC_PAGE_PATHS.AGENT, {
          merchantId: merchantStructure.merchant.id,
          channelId: selectedChannel.id,
          agentId,
        })
      : undefined;

  return (
    <>
      {agents.map((agent, index) => {
        const isAgentFound = agentFoundBySearch?.id === agent.id;
        if (!agentSearchTerm && isAgentFound) return null;
        return (
          <AgentCard
            key={index}
            redirectPath={isAgentRedirectAllowed ? redirectPath(agent.id) : undefined}
            agent={agent}
            merchantStructure={merchantStructure}
            isOutlined={isAgentFound}
            isMobile={isMobile}
            editModeAllowed={editModeAllowed}
          />
        );
      })}
    </>
  );
};
